import http from 'src/services/utils/http';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';

export interface AcceptInvitationParams {
  token: string;
  firstName: string;
  lastName: string;
}

const acceptInvitation: MutationFunction<
  AcceptInvitationParams,
  AcceptInvitationParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockStackFilter(args), { delay: 4000, failureRate: 1 });
  const response = await http<AcceptInvitationParams>(
    `/shared/invites/${args.token}/accept`,
    {
      method: 'POST',
      body: {
        firstName: args.firstName,
        lastName: args.lastName,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to accept invitation');
};

export default acceptInvitation;

const _mockStackFilter = (args: AcceptInvitationParams) => {
  return args;
};
